import type { TypeContentBlockWithoutUnresolvableLinksResponse } from '~/types/contentful'
import type { PageVisibilityStatus } from '~/composables/usePageVisibility'

export function shouldRenderGlobalSiteNotification(
  notification:
    | TypeContentBlockWithoutUnresolvableLinksResponse
    | null
    | undefined,
  visibilityStatus: PageVisibilityStatus,
) {
  return (
    notification?.fields?.renderAs === 'SlimBanner' &&
    visibilityStatus === 'visible'
  )
}
